import { useEffect } from 'react';
import { useSubscription, useApolloClient } from '@apollo/client';
import { CrewMember, PersonaType, WeldProcedureSubscriptionPayload } from '@bechtel/types';
import { SUBSCRIPTION_WELD_PROCEDURE_UPDATED } from '@bechtel/client-gql';
import { useAppUser, CacheKeys, useEnvProvider, ProjectAppTypes, useModulePermission } from '@bechtel/client-common';
import { includes } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useRodRoomPermissions } from '../use-rod-room-permissions';
import { useWeldPermissions } from '../use-weld-permissions';
export function useWeldProcedureSubscription() {
  const { data: updatedWeldProcedureData } = useSubscription<{
    weldProcedureUpdated: WeldProcedureSubscriptionPayload;
  }>(SUBSCRIPTION_WELD_PROCEDURE_UPDATED);
  const client = useApolloClient();
  const { user } = useAppUser();
  const { envConfig } = useEnvProvider();
  const { canViewRodRoomModule } = useModulePermission();
  const location = useLocation();
  const dashboardSelectedUser: CrewMember = JSON.parse(sessionStorage.getItem(CacheKeys.DashboardSelectedUser));

  const assignee: CrewMember = dashboardSelectedUser || user?.crewMember;
  const { canCreateRodRequest, canCreateAdhocRodRequest, canUpdateRodRequest } = useRodRoomPermissions(
    assignee ? [{ assignee }] : []
  );
  const { canClaimWeld } = useWeldPermissions(assignee ? [{ assignee }] : []);
  const personas = [
    PersonaType.SUPERINTENDENT,
    PersonaType.GENERAL_FOREMAN,
    PersonaType.FOREMAN,
    PersonaType.FIELD_WELD_ENGINEER,
    PersonaType.ROD_ROOM_ATTENDANT,
  ];
  const isASAppType = envConfig.appName === ProjectAppTypes.AS;
  const fetchloadWeldProcedures = async () => {
    await client.refetchQueries({
      include: ['loadWeldProcedures'],
    });
  };

  useEffect(() => {
    if (
      !updatedWeldProcedureData ||
      !updatedWeldProcedureData?.weldProcedureUpdated ||
      !updatedWeldProcedureData?.weldProcedureUpdated?.weldProcedureIds ||
      updatedWeldProcedureData?.weldProcedureUpdated?.weldProcedureIds?.length === 0
    )
      return;
    const pathName = location.pathname;
    const hasFweDashboardPermission =
      (user?.crewMember?.persona === PersonaType.FIELD_WELD_ENGINEER ||
        dashboardSelectedUser?.persona === PersonaType.FIELD_WELD_ENGINEER) &&
      ((canViewRodRoomModule && (canCreateRodRequest || canUpdateRodRequest)) || canClaimWeld);
    if (
      (isASAppType && pathName && pathName === '/' && hasFweDashboardPermission) ||
      (pathName === '/' &&
        (dashboardSelectedUser
          ? dashboardSelectedUser?.persona !== PersonaType.FIELD_WELD_ENGINEER
          : user?.crewMember?.persona !== PersonaType.FIELD_WELD_ENGINEER)) ||
      (pathName.includes('/rod-room/requests') &&
        canViewRodRoomModule &&
        (canCreateAdhocRodRequest || canUpdateRodRequest)) ||
      (pathName.includes('/welds') && ((canViewRodRoomModule && canCreateRodRequest) || canClaimWeld))
    ) {
      if (!(includes(personas, user?.crewMember?.persona) || includes(personas, dashboardSelectedUser?.persona)))
        return;
      fetchloadWeldProcedures();
    }
  }, [updatedWeldProcedureData]);

  return null;
}
